module.exports = __webpack_public_path__ + "img/app_android.5acbff91.png";